import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class HelpersService {
  public hasBanner: Subject<boolean> = new Subject();

  constructor() {}

  device = {
    xlarge: 1440,
    large: 1024,
    medium: 768,
    small: 375,

    isTouchDevice: function() {
      return 'ontouchstart' in window;
    },
    isXsOnly: function(width = this.getWidth()) {
      return width < this.small;
    },
    isSmUp: function(width = this.getWidth()) {
      return width >= this.small;
    },
    isSmOnly: function(width = this.getWidth()) {
      return width >= this.small && this.getWidth() < this.medium;
    },
    isMdUp: function(width = this.getWidth()) {
      return width >= this.medium;
    },
    isMdOnly: function(width = this.getWidth()) {
      return width >= this.medium && this.getWidth() < this.large;
    },
    isLgUp: function(width = this.getWidth()) {
      return width >= this.large;
    },
    isLgOnly: function(width = this.getWidth()) {
      return width >= this.large && this.getWidth() <= this.xlarge;
    },
    isXlUp: function(width = this.getWidth()) {
      return width > this.xlarge;
    },
    getWidth: function() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
  };

  scroll(targetEl) {
    targetEl.scrollIntoView();
  }

  smoothScrollTo(x: number, y: number) {
    const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
    if (isSmoothScrollSupported) {
      // Native smooth scrolling
      window.scrollTo({
        behavior: 'smooth',
        left: x,
        top: y
      });
    } else {
      // Old way scrolling without effects
      window.scrollTo(x, y);
    }
  }

  toggleAccordionOpenClass(event) {
    if (event.isOpen) {
      return event.index;
    } else {
      return 0;
    }
  }
}
